export const GET_USERS = 'user/getUsers';
export const GET_USER = 'user/getUser';
export const CREATE_USER = 'user/createUser';
export const CREATE_USERS = 'user/createUsers';
export const UPDATE_USER = 'user/updateUser';
export const DELETE_USER = 'user/deleteUser';
